import { styled } from '@mui/material/styles';
import { Card, Paper } from '@mui/material';
import { alpha } from '@mui/material/styles';

export const HeaderCard = styled(Card)(({ theme }) => ({
  borderRadius: 16,
  border: `1px solid ${alpha(theme.palette.grey[400], 0.6)}`,
  background: theme.palette.grey[100],
  backdropFilter: 'blur(20px)',
  boxShadow: `0 8px 32px ${alpha(theme.palette.primary.main, 0.12)}`,
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: 3,
    background: `linear-gradient(90deg, ${theme.palette.primary.main}, white)`,
    opacity: 0.8
  }
}));

export const SectionPaper = styled(Paper)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  padding: theme.spacing(3),
  borderRadius: 12,
  background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.04)}, ${alpha(theme.palette.primary.main, 0.01)})`,
  border: `1px solid ${alpha(theme.palette.grey[400], 0.6)}`,
  boxShadow: `0 8px 24px ${alpha(theme.palette.primary.main, 0.12)}`,
  transition: 'transform 0.2s ease, box-shadow 0.2s ease',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: `0 12px 32px ${alpha(theme.palette.primary.main, 0.2)}`
  }
}));

